import { defaultModalOptions } from '@/constants/modal-options'
import { ModalType } from '@/enums/modal-type'
import type { Snack } from '@shared/interfaces/snack'
import { toRaw, type Ref } from 'vue'
import ModalHelperService from './modal-helper'

class SupportedSnacksModalHelperService {
  private preSelectedSnacks?: Snack[]
  public hideResolver?: (value?: Snack[]) => void

  constructor() {}

  public init(
    modalRef: Ref<HTMLDivElement | undefined>,
    preSelectedSnacks: Ref<Snack[] | undefined>,
    isVisible: Ref<boolean>
  ): void {
    ModalHelperService.init(ModalType.SUPPORTED_SNACKS, modalRef.value!, {
      ...defaultModalOptions,
      onShow: (modal) => {
        preSelectedSnacks.value = this.preSelectedSnacks

        isVisible.value = modal.isVisible()
      },
      onHide: (modal) => {
        this.preSelectedSnacks = undefined
        isVisible.value = modal.isVisible()
      }
    })
  }

  public show(preSelectedValues?: Snack[]): Promise<Snack[] | undefined> {
    return new Promise<Snack[] | undefined>((resolve) => {
      this.preSelectedSnacks = preSelectedValues ? [...toRaw(preSelectedValues)] : undefined

      this.hideResolver = resolve
      ModalHelperService.show(ModalType.SUPPORTED_SNACKS)
    })
  }

  public hide(selectedSnacks?: Snack[]): void {
    ModalHelperService.hide(ModalType.SUPPORTED_SNACKS)
    if (this.hideResolver) {
      this.hideResolver(toRaw(selectedSnacks))
    }
  }
}
export default new SupportedSnacksModalHelperService()
